import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControlLabel,
  Link,
  Popover,
  Radio,
  Switch,
  Typography,
} from "@mui/material";
import { ArrowDropDownIcon, DateRangeIcon } from "@mui/x-date-pickers";
import * as React from "react";
import CheckboxList from "../common/CheckboxList";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { formatToUsDateFromUTCNew } from "../utils/DateHelper";

interface Props {
  startDate?: any;
  endDate?: any;
  actionTypes: any;
  providerLists: any;
  categories: any;
  anchorEl: any;
  setAnchorEl: Function;
  checkedAction: any;
  setCheckedAction: Function;
  checkedProviders: any;
  setCheckedProviders: Function;
  checkedCategories: any;
  setCheckedCategories: Function;
  setDateFilterDefault: Function;
  setShowCompleted: Function;
  setSortType: Function;
  showCompleted: any;
  sortType: any;
  initialEndDate?: any;
  initialStartDate?: any;
  handleStartDateChange: (date: Date, value?: string) => void;
  handleEndDateChange: (date: Date, value?: string) => void;
  insuranceTypeOptions: string[];
  insurancePlanNameOptions: string[];
  programNames: string[];
  checkedInsuranceTypes: any[];
  setCheckedInsuranceTypes: Function;
  checkedInsurancePlanNames: any[];
  setCheckedInsurancePlanNames: Function;
  checkedProgramNames: any[];
  setCheckedProgramNames: Function;
}

const FilterMenu: React.FC<Props> = ({
  startDate,
  endDate,
  actionTypes,
  providerLists,
  categories,
  anchorEl,
  setAnchorEl,
  checkedAction,
  setCheckedAction,
  checkedProviders,
  setCheckedProviders,
  checkedCategories,
  setCheckedCategories,
  setDateFilterDefault,
  setShowCompleted,
  setSortType,
  showCompleted,
  insuranceTypeOptions,
  insurancePlanNameOptions,
  programNames,
  checkedInsuranceTypes,
  setCheckedInsuranceTypes,
  checkedInsurancePlanNames,
  setCheckedInsurancePlanNames,
  checkedProgramNames,
  setCheckedProgramNames,
  sortType,
  initialEndDate,
  initialStartDate,
  handleStartDateChange,
  handleEndDateChange,
}) => {
  const [actionTypeExpanded, setActionTypesExpanded] = React.useState(true);
  const [providersExpanded, setProvidersExpanded] = React.useState(false);
  const [sortingExpanded, setSortingExpanded] = React.useState(false);
  const [categoriesExpanded, setCategoriesExpanded] = React.useState(false);
  const [showStartDatePicker, setShowStartDatePicker] = React.useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = React.useState(false);
  const [insuranceTypesExpanded, setInsuranceTypesExpanded] =
    React.useState(false);
  const [insurancePlanNamesExpanded, setInsurancePlanNamesExpanded] =
    React.useState(false);
  const [programNamesExpanded, setProgramNamesExpanded] = React.useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const accordionHeight = "20px";

  const clearAllFilters = () => {
    setCheckedAction("All Actions");
    setShowCompleted(false);
    setSortType("chronological");
    setCheckedProviders([]);
    setCheckedCategories([]);
    setCheckedInsuranceTypes([]);
    setCheckedInsurancePlanNames([]);
    setCheckedProgramNames([]);
    setDateFilterDefault();
    handleClose();
  };

  const keyboardDatePickerProps: any = {
    variant: "inline",
    format: "MM/dd/yyyy",
    keyboardIcon: (
      <DateRangeIcon sx={{ "&.MuiSvgIcon-root": { fontSize: 16 } }} />
    ),
    InputAdornmentProps: { style: { margin: 0 } },
    KeyboardButtonProps: { style: { padding: 0 } },
    InputProps: {
      disableUnderline: true,
      inputProps: {
        style: {
          fontSize: 10,
          color: "#A29D9B",
          padding: 0,
          width: 60,
        },
      },
    },
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div className="popover-filter-container">
        <div className="header-wrapper">
          <div className="header">Filters</div>
          {(checkedAction !== null ||
            checkedProviders.length > 0 ||
            checkedCategories.length > 0) && (
            <button onClick={clearAllFilters} className="clear-all">
              <svg
                width="9"
                height="9"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="7.99902"
                  width="8"
                  height="8"
                  rx="1"
                  transform="rotate(-90 0 7.99902)"
                  fill="#FF890A"
                />
                <path
                  d="M2.13699 1.66585L1.66699 2.13585L3.53033 3.99919L1.66699 5.86252L2.13699 6.33252L4.00033 4.46919L5.86366 6.33252L6.33366 5.86252L4.47033 3.99919L6.33366 2.13585L5.86366 1.66585L4.00033 3.52919L2.13699 1.66585Z"
                  fill="white"
                />
              </svg>
              <span>Clear All</span>
            </button>
          )}
        </div>
        <div
          className="tag-number"
          style={{
            marginTop: "2px",
            display: "flex",
            whiteSpace: "nowrap",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            Actions from&nbsp;
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              value={startDate ? formatToUsDateFromUTCNew(startDate) : null}
              onChange={(date) => {
                setShowStartDatePicker(false);
                handleStartDateChange(date);
              }}
              style={{ margin: 0, marginRight: 1, verticalAlign: "baseline" }}
              open={showStartDatePicker}
              onOpen={() => setShowStartDatePicker(true)}
              onClose={() => setShowStartDatePicker(false)}
              ToolbarComponent={() => (
                <Link
                  sx={{
                    fontSize: "14px",
                    order: 1,
                    textAlign: "right",
                    padding: "15px",
                    paddingTop: "0",
                  }}
                  onClick={() => {
                    handleStartDateChange(new Date(initialStartDate));
                    setShowStartDatePicker(false);
                  }}
                >
                  Clear
                </Link>
              )}
              {...keyboardDatePickerProps}
            />
          </MuiPickersUtilsProvider>
          <span style={{}}> - </span>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              value={endDate ? formatToUsDateFromUTCNew(endDate) : null}
              onChange={(date) => {
                setShowEndDatePicker(false);
                handleEndDateChange(date);
              }}
              style={{ margin: 0, marginLeft: 1, verticalAlign: "baseline" }}
              open={showEndDatePicker}
              onOpen={() => setShowEndDatePicker(true)}
              onClose={() => setShowEndDatePicker(false)}
              ToolbarComponent={() => (
                <Link
                  sx={{
                    fontSize: "14px",
                    order: 1,
                    textAlign: "right",
                    padding: "15px",
                    paddingTop: "0",
                  }}
                  onClick={() => {
                    handleEndDateChange(new Date(initialEndDate));
                    setShowEndDatePicker(false);
                  }}
                >
                  Clear
                </Link>
              )}
              {...keyboardDatePickerProps}
            />
          </MuiPickersUtilsProvider>
        </div>

        <Accordion
          expanded={actionTypeExpanded}
          onChange={() => setActionTypesExpanded(!actionTypeExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "10px 20px 12px 10px",
            }}
          >
            {actionTypes.map((list, index) => {
              const handleSelection = (list) => {
                if (checkedAction === list.title) {
                  setCheckedAction("All Actions");
                } else {
                  setCheckedAction(list.title);
                }
              };

              return (
                <div className="multiple-checkbox" key={index}>
                  <div className="checkbox-row-containter no-margin-bottom">
                    <Radio
                      checked={checkedAction === list.title}
                      onClick={() => handleSelection(list)}
                      value={list.title}
                      name="radio-buttons"
                      inputProps={{ "aria-label": list }}
                      style={{
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }}
                      sx={{
                        color: "#A29D9B",
                        "&.MuiButtonBase-root": {
                          padding: "9px",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "12px",
                        },
                      }}
                    />
                    <div
                      className="option-text"
                      onClick={() => handleSelection(list)}
                      style={{ cursor: "pointer" }}
                    >
                      {list.title}
                      <span className="tool-badge">{list.count}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </AccordionDetails>
        </Accordion>
        {checkedAction === "My Actions" ||
        checkedAction === "Unassigned Actions" ? (
          <></>
        ) : (
          <Accordion
            expanded={providersExpanded}
            onChange={() => setProvidersExpanded(!providersExpanded)}
            sx={{
              boxShadow: "none",
              border: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={null}
              sx={{
                padding: 0,
                minHeight: accordionHeight,
                "&.MuiAccordionSummary-root": {
                  minHeight: accordionHeight,
                },
                "&.MuiAccordionSummary-gutters": {
                  padding: 0,
                  minHeight: accordionHeight,
                },
                "&.Mui-expanded": {
                  minHeight: accordionHeight,
                },
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                  alignItems: "center",
                  minHeight: accordionHeight,
                },
                "& .MuiAccordionSummary-contentGutters": {
                  marginBottom: "10px",
                  minHeight: accordionHeight,
                },
                "& .MuiAccordionSummary-content.Mui-expanded": {
                  margin: 0,
                  minHeight: accordionHeight,
                  alignItems: "center",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  p: "0 20px 0 12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    transform: providersExpanded
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  }}
                >
                  <ArrowDropDownIcon />
                </Box>
                <p className="collapse-list-header">Providers</p>
              </Box>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: 0,
                backgroundColor: "#F8F8F8",
                p: "20px 20px 12px 16px",
              }}
            >
              <CheckboxList
                items={providerLists.map((type) => ({
                  id: type.id,
                  label: (
                    <div>
                      {type.title}
                      <span className="tool-badge">{type.count}</span>
                    </div>
                  ),
                }))}
                checkedItems={checkedProviders}
                setCheckedItems={setCheckedProviders}
                labelField="label"
              />
            </AccordionDetails>
          </Accordion>
        )}
        <Accordion
          expanded={insuranceTypesExpanded}
          onChange={() => setInsuranceTypesExpanded(!insuranceTypesExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: accordionHeight,
              "&.MuiAccordionSummary-root": {
                minHeight: accordionHeight,
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: accordionHeight,
              },
              "&.Mui-expanded": {
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: accordionHeight,
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: insuranceTypesExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Insurance Type</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <CheckboxList
              items={(insuranceTypeOptions || []).map((type) => ({
                id: type,
                label: type,
              }))}
              checkedItems={checkedInsuranceTypes || []}
              setCheckedItems={setCheckedInsuranceTypes || (() => {})}
              labelField="label"
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={insurancePlanNamesExpanded}
          onChange={() =>
            setInsurancePlanNamesExpanded(!insurancePlanNamesExpanded)
          }
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: accordionHeight,
              "&.MuiAccordionSummary-root": {
                minHeight: accordionHeight,
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: accordionHeight,
              },
              "&.Mui-expanded": {
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: accordionHeight,
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: insurancePlanNamesExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Insurance Plans</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <CheckboxList
              items={(insurancePlanNameOptions || []).map((type) => ({
                id: type,
                label: type,
              }))}
              checkedItems={checkedInsurancePlanNames || []}
              setCheckedItems={setCheckedInsurancePlanNames || (() => {})}
              labelField="label"
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={programNamesExpanded}
          onChange={() => setProgramNamesExpanded(!programNamesExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: accordionHeight,
              "&.MuiAccordionSummary-root": {
                minHeight: accordionHeight,
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: accordionHeight,
              },
              "&.Mui-expanded": {
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: accordionHeight,
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: programNamesExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Program Names</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <CheckboxList
              items={(programNames || []).map((type) => ({
                id: type,
                label: type,
              }))}
              checkedItems={checkedProgramNames || []}
              setCheckedItems={setCheckedProgramNames || (() => {})}
              labelField="label"
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={sortingExpanded}
          onChange={() => setSortingExpanded(!sortingExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: accordionHeight,
              "&.MuiAccordionSummary-root": {
                minHeight: accordionHeight,
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: accordionHeight,
              },
              "&.Mui-expanded": {
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: accordionHeight,
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: sortingExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Sort</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                borderRadius: "4px",
                flexDirection: "column",
                gap: 1,
                marginLeft: "16px",
              }}
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={showCompleted || false}
                    onChange={(e) => setShowCompleted?.(e.target.checked)}
                    color="primary"
                    size="small"
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.6rem", marginLeft: "4px" }}
                  >
                    Show Historically Completed Actions
                  </Typography>
                }
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={categoriesExpanded}
          onChange={() => setCategoriesExpanded(!categoriesExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: accordionHeight,
              "&.MuiAccordionSummary-root": {
                minHeight: accordionHeight,
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: accordionHeight,
              },
              "&.Mui-expanded": {
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: accordionHeight,
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: accordionHeight,
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: categoriesExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Advanced Categories</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <CheckboxList
              items={categories.map((type) => ({
                id: type.title,
                label: (
                  <div>
                    {type.title}
                    <span className="tool-badge">{type.count}</span>
                  </div>
                ),
              }))}
              checkedItems={checkedCategories}
              setCheckedItems={setCheckedCategories}
              labelField="label"
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </Popover>
  );
};

export default FilterMenu;
